var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNextArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flecha 1 banner"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_d_1194_199)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 22.5C3 33.2691 11.7309 42 22.5 42C33.2691 42 42 33.2691 42 22.5C42 11.7309 33.2691 3 22.5 3C11.7309 3 3 11.7309 3 22.5ZM27.1284 22.5L19.1897 14.5603C18.9203 14.2767 18.7723 13.8991 18.7773 13.508C18.7823 13.1168 18.9399 12.7431 19.2165 12.4665C19.4931 12.1899 19.8668 12.0323 20.258 12.0273C20.6491 12.0223 21.0267 12.1703 21.3103 12.4397L30.3103 21.4397C30.5914 21.721 30.7493 22.1023 30.7493 22.5C30.7493 22.8977 30.5914 23.279 30.3103 23.5603L21.3103 32.5603C21.0267 32.8297 20.6491 32.9777 20.258 32.9727C19.8668 32.9677 19.4931 32.8101 19.2165 32.5335C18.9399 32.2569 18.7823 31.8832 18.7773 31.492C18.7723 31.1009 18.9203 30.7233 19.1897 30.4397L27.1284 22.5Z",
    fill: "white",
    fillOpacity: 0.8,
    shapeRendering: "crispEdges"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1194_199",
    x: 0,
    y: 0,
    width: 49,
    height: 49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.53 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1194_199"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1194_199",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextArrow);
export default __webpack_public_path__ + "static/media/next-arrow.2ba0ba7959191b9aab801bd00d47c413.svg";
export { ForwardRef as ReactComponent };